// import logo from './logo.svg';
// import './App.css';

import React from "react";
import { AuthContextProvider } from "./context/AuthContext";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { RouterProvider } from "react-router-dom";

import Navbar from "./components/Navigation/Navigation";
import router from "./router/router";

const theme = createTheme({
  palette: {
    eestecred: {
      main: "#e52a30",
    },
  },
});

function App() {
  return (
    <div className="App dark-theme">
      <ThemeProvider theme={theme}>
        <AuthContextProvider>
          <Navbar />
          <RouterProvider router={router} />
        </AuthContextProvider>
      </ThemeProvider>

      {/* <div className="bottom-version"> {strings.global.version} </div> */}
    </div>
  );
}

export default App;
